export default __webpack_public_path__ + "static/media/MainLogo.943c5958.svg";